export default __webpack_public_path__ + "static/corporate-governance-7ff7eb14f9eb51b9c5e9c13c8d9923dd.png";